import { render } from "./CreateRequest3.vue?vue&type=template&id=6b9ed9f4"
import script from "./CreateRequest3.vue?vue&type=script&lang=js"
export * from "./CreateRequest3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__